/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function UpdateAWPackage1901Info(formData) {
  const response = await $.soap({
    body: {
      UpdateAWPackage1901Info: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackage1901: {
          AWPackageID: formData.awPackageId,
          PeriodOfPerformance: formData.periodOfPerformance,
          CustomerName: formData.orgNameCustomer,
          CustomerPOCFirstName: formData.pocFirstNameCustomer,
          CustomerPOCLastName: formData.pocLastNameCustomer,
          CustomerPOCMiddleInitial: formData.pocMiddleInitialCustomer,
          CustomerPOCEmail: formData.pocEmailCustomer,
          CustomerPOCPhone: formData.pocPhoneCustomer,
          CustomerPOCFax: formData.pocFaxVendor,
          VendorName: formData.orgNameVendor,
          VendorPOCFirstName: formData.pocFirstNameVendor,
          VendorPOCLastName: formData.pocLastNameVendor,
          VendorPOCMiddleInitial: formData.pocMiddleInitialVendor,
          VendorPOCEmail: formData.pocEmailVendor,
          VendorPOCPhone: formData.pocPhoneVendor,
          VendorPOCFax: formData.pocFaxCustomer,
        },
        CustomerAddress: {
          Address1: formData.addressCustomer.address1,
          BuildingFloorNumber: formData.addressCustomer.buildingFloorNumber,
          RoomPoleNumber: formData.addressCustomer.roomPoleNumber,
          City: formData.addressCustomer.city,
          Zip: formData.addressCustomer.zip,
          RegionID: formData.addressCustomer.regionId
        },
        VendorAddress: {
          Address1: formData.addressVendor.address1,
          BuildingFloorNumber: formData.addressVendor.buildingFloorNumber,
          RoomPoleNumber: formData.addressVendor.roomPoleNumber,
          City: formData.addressVendor.city,
          Zip: formData.addressVendor.zip,
          RegionID: formData.addressVendor.regionId
        }
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
